module.exports = __webpack_public_path__ + "static/media/sf-test-13.c3ad8a4c.mp3";